import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "alert",
  "use": "alert-usage",
  "viewBox": "0 0 16 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 13\" id=\"alert\"><g fill-rule=\"nonzero\" fill=\"none\"><path d=\"M8.852 1.383l6.21 10.084a1 1 0 01-.852 1.524H1.79a1 1 0 01-.851-1.524l6.21-10.084a1 1 0 011.703 0z\" fill=\"#FC0\" /><path fill=\"#333\" d=\"M7.111 4.365h1.778v4.333H7.111zM7.111 9.565h1.778v1.733H7.111z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id